var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTl = function SvgTl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h682.67v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    transform: "scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cb000f",
    d: "M0 0h1031.2v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.234 0 512 256.72 512 256.72L0 512V0z",
    fill: "#f8c00c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.151 0 340.62 256.72 340.62 256.72L0 512V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.71 298.16l-60.813-13.478-31.072 52.839-4.861-59.677-60.753-13.372 54.84-24.817-3.292-59.385 40.235 43.39 55.341-25.232-28.827 53.899 39.203 45.835z",
    fill: "#fff"
  }))));
};
export default __webpack_public_path__ + "assets/e1b4bdfd4ddaecc1dede27db9c98c285.svg";
export { SvgTl as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/tl.svg